module.exports = __webpack_public_path__ + "img/Rectangle 37.988ad62d.png";